import { Slot } from '@radix-ui/react-slot'
import { cn } from '@repo/ui/utils'
import { ButtonHTMLAttributes, forwardRef } from 'react'

interface LinkProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  asChild?: boolean
}

export const Link = forwardRef<HTMLButtonElement, LinkProps>(
  // TODO: add tooltip
  ({ asChild = false, className, ...props }, ref) => {
    const Comp = asChild ? Slot : 'button'
    return (
      <Comp
        ref={ref}
        type={props.type || 'button'}
        className={cn(
          'flex w-fit select-none items-center gap-1 text-sm focus:outline-none',
          !props.disabled &&
            'data-[state=open]:text-primary text-primary-500 hover:text-primary cursor-pointer underline transition-colors data-[state=open]:underline',
          className,
        )}
        {...props}
      >
        {props.children}
      </Comp>
    )
  },
)
